webpackJsonp([35783957827783],{

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Card----Card-module---root---1wCxR","body":"src-components-Card----Card-module---body---9ikbc"};

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CardBody = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CardModule = __webpack_require__(102);
	
	var _CardModule2 = _interopRequireDefault(_CardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  var classes = (0, _classnames2.default)(_CardModule2.default.root, className);
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    children
	  );
	};
	
	var CardBody = exports.CardBody = function CardBody(_ref2) {
	  var children = _ref2.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _CardModule2.default.body },
	    children
	  );
	};
	
	exports.default = Card;

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Container----Container-module---root---1CjkY","isNarrow":"src-components-Container----Container-module---isNarrow---r_MTP","isCentered":"src-components-Container----Container-module---isCentered---2tQ8f"};

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ContainerModule = __webpack_require__(103);
	
	var _ContainerModule2 = _interopRequireDefault(_ContainerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = function Container(props) {
	  var _classNames;
	
	  var _props$isNarrow = props.isNarrow,
	      isNarrow = _props$isNarrow === undefined ? false : _props$isNarrow,
	      children = props.children,
	      _props$isCentered = props.isCentered,
	      isCentered = _props$isCentered === undefined ? true : _props$isCentered,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === undefined ? null : _props$maxWidth;
	
	  var inlineStyles = {};
	  var classes = (0, _classnames2.default)(_ContainerModule2.default.root, (_classNames = {}, _classNames[_ContainerModule2.default.isNarrow] = isNarrow, _classNames[_ContainerModule2.default.isCentered] = isCentered, _classNames));
	  console.log('Classes ---> ', classes, _ContainerModule2.default);
	
	  if (maxWidth) {
	    inlineStyles.maxWidth = maxWidth;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes, style: inlineStyles },
	    children
	  );
	};
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectsWrapper":"src-components-Projects----Projects-module---projectsWrapper---2yQ9-","title":"src-components-Projects----Projects-module---title---3yFPK","project":"src-components-Projects----Projects-module---project---3lMBH","projectImg":"src-components-Projects----Projects-module---projectImg---3N4Cu","projectLink":"src-components-Projects----Projects-module---projectLink---11dmK","projectInfo":"src-components-Projects----Projects-module---projectInfo---2HxfL","projectTitle":"src-components-Projects----Projects-module---projectTitle---yA2pn"};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(75);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _imageHelper = __webpack_require__(207);
	
	var _ProjectsModule = __webpack_require__(302);
	
	var _ProjectsModule2 = _interopRequireDefault(_ProjectsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectTags = function ProjectTags(_ref) {
	  var tags = _ref.tags;
	
	  if (!tags) return null;
	  return _react2.default.createElement(
	    'ul',
	    null,
	    tags.map(function (tag) {
	      return _react2.default.createElement(
	        'li',
	        { key: tag },
	        tag
	      );
	    })
	  );
	};
	
	var Projects = function Projects(_ref2) {
	  var projects = _ref2.projects,
	      title = _ref2.title;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    title && _react2.default.createElement(
	      'h2',
	      { className: 'title beta ' + _ProjectsModule2.default.title },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _ProjectsModule2.default.projectsWrapper },
	      projects.map(function (node) {
	        var imageUrl = (0, _imageHelper.getProjectImage)(node.node.id);
	        return _react2.default.createElement(
	          _Card2.default,
	          { className: _ProjectsModule2.default.project, key: node.node.id },
	          _react2.default.createElement(
	            'article',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: node.node.url, className: _ProjectsModule2.default.projectLink, target: '_blank' },
	              _react2.default.createElement('img', { src: imageUrl, className: _ProjectsModule2.default.projectImg }),
	              _react2.default.createElement(
	                'div',
	                { className: _ProjectsModule2.default.projectInfo },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'title gamma ' + _ProjectsModule2.default.projectTitle },
	                  node.node.name
	                ),
	                _react2.default.createElement(ProjectTags, { tags: node.node.tags })
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Skills----Skills-module---root---2NKQW","title":"src-components-Skills----Skills-module---title---mYnA0","tag":"src-components-Skills----Skills-module---tag---14oJB"};

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SkillsModule = __webpack_require__(303);
	
	var _SkillsModule2 = _interopRequireDefault(_SkillsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Skills = function Skills(_ref) {
	  var groups = _ref.groups;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _SkillsModule2.default.root },
	    groups.map(function (group) {
	      return _react2.default.createElement(
	        'dl',
	        { className: _SkillsModule2.default.group, key: group.node.id },
	        _react2.default.createElement(
	          'dt',
	          { className: _SkillsModule2.default.title + ' beta title' },
	          group.node.id
	        ),
	        group.node.items.map(function (item) {
	          return _react2.default.createElement(
	            'dd',
	            { key: item.name, className: _SkillsModule2.default.tag },
	            item.name
	          );
	        })
	      );
	    })
	  );
	};
	
	exports.default = Skills;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TextModule = __webpack_require__(304);
	
	var _TextModule2 = _interopRequireDefault(_TextModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Text = function Text(_ref) {
	  var _classNames;
	
	  var _ref$isBody = _ref.isBody,
	      isBody = _ref$isBody === undefined ? false : _ref$isBody,
	      className = _ref.className,
	      children = _ref.children,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === undefined ? 'p' : _ref$tagName,
	      _ref$isHtml = _ref.isHtml,
	      isHtml = _ref$isHtml === undefined ? false : _ref$isHtml;
	
	  var classes = (0, _classnames2.default)(_TextModule2.default.root, className, (_classNames = {}, _classNames[_TextModule2.default.isBody] = isBody, _classNames[_TextModule2.default.isHtml] = isHtml, _classNames));
	
	  if (isHtml) {
	    return _react2.default.createElement('div', { dangerouslySetInnerHTML: children, className: classes });
	  }
	
	  var TagName = tagName;
	
	  return _react2.default.createElement(
	    TagName,
	    { className: classes },
	    children
	  );
	};
	
	exports.default = Text;
	module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----Text-module---root---UhyL-","isBody":"src-components----Text-module---isBody---NFI0y","isHtml":"src-components----Text-module---isHtml---23St5"};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getProjectImage = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projectHermods = __webpack_require__(450);
	
	var _projectHermods2 = _interopRequireDefault(_projectHermods);
	
	var _projectIntra = __webpack_require__(451);
	
	var _projectIntra2 = _interopRequireDefault(_projectIntra);
	
	var _projectUniross = __webpack_require__(452);
	
	var _projectUniross2 = _interopRequireDefault(_projectUniross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getProjectImage = exports.getProjectImage = function getProjectImage(id) {
	  switch (id) {
	    case 'hermods':
	      return _projectHermods2.default;
	    case 'intra':
	      return _projectIntra2.default;
	    case 'uniross':
	      return _projectUniross2.default;
	    default:
	      return null;
	  }
	};

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/project-hermods.c33ac9e5.jpg";

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/project-intra.297f68c7.jpg";

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/project-uniross.31ca1882.jpg";

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Projects = __webpack_require__(204);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _Skills = __webpack_require__(205);
	
	var _Skills2 = _interopRequireDefault(_Skills);
	
	var _Container = __webpack_require__(54);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Text = __webpack_require__(206);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _indexModule = __webpack_require__(306);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPageFragmentHtml(query) {
	  return { __html: query.edges[0].node.html };
	}
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Container2.default,
	      { isCentered: true },
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.body },
	        _react2.default.createElement(
	          _Text2.default,
	          { isHtml: true },
	          getPageFragmentHtml(data.about)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          { isHtml: true },
	          getPageFragmentHtml(data.focus)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          { isHtml: true },
	          getPageFragmentHtml(data.education)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          { isHtml: true },
	          getPageFragmentHtml(data.experience)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      { maxWidth: '1220' },
	      _react2.default.createElement(_Projects2.default, { title: 'Projects', projects: data.allProjectsJson.edges })
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      { maxWidth: '1220' },
	      _react2.default.createElement(_Skills2.default, { groups: data.allToolsJson.edges })
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"body":"src-pages----index-module---body---3CZU5"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-50eb0f5f92ab9bc2ce60.js